<template>
  <div class="Crisis_detail">
    <div class="hoi">
      <el-descriptions title="重点台账明细" direction="vertical" :column="4" border>
        <el-descriptions-item label="学生姓名">{{data.realName}}</el-descriptions-item>
        <el-descriptions-item label="学生学号">{{data.userID}}</el-descriptions-item>
        <el-descriptions-item label="五困类型">{{FiveDifficultySplicing}}</el-descriptions-item>
        <el-descriptions-item label="发现途径">{{fxtj.toString()}}</el-descriptions-item>
        <el-descriptions-item label="自杀、自伤或伤害他人倾向 (是否)">{{data.suicidalFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="疑似重性精神障碍 (是否)">{{data.psychosesFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="就医情况 (是否)">{{data.hospitalFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="医院">{{data.hospitalName}}</el-descriptions-item>
        <el-descriptions-item label="诊断结果">{{data.hospitalDetail}}</el-descriptions-item>
        <el-descriptions-item label="服药情况 (是否)">{{data.medicineFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="是否在心理中心咨询 (是否)">{{data.counsultFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="咨询开始时间">{{data.counsultBegin}}</el-descriptions-item>
        <el-descriptions-item label="咨询次数">{{data.counsultTimes}}</el-descriptions-item>
        <el-descriptions-item label="风险监控员初核意见">{{data.riskMonitorCheckDetail}}</el-descriptions-item>
        <el-descriptions-item label="危机主管复核意见">{{data.criAdminCheckDetail}}</el-descriptions-item>
      </el-descriptions>
    </div>

    <el-button v-if="(urgentStatus == '' ||urgentStatus == null) && reportStatus=='待咨询主管审核' && RoleID==1066" type="primary" @click="dialogVisible=true" style="margin:30px auto;display: block;">安排咨询师介入</el-button>
    <el-dialog title="绑定咨询师" :visible.sync="dialogVisible" width="40%"  :before-close="handleClose">
      <div style="height: 500px;">
        <el-form ref="form"  style="width: 650px;float: left;height: 100%; height: 600px;" :model="form" label-width="80px">

        <el-form-item label="咨询师" prop="Consultant">
          <el-select v-model="form.Consultant" placeholder="请选择咨询师">
            <el-option v-for="(item, itemIndex) in CounselorList" :key="itemIndex" :label="item.UserName" :value="item.UserID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="咨询日期" prop="SchedulDate">
          <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="form.SchedulDate"   align="right"   type="date"   placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="咨询地点" prop="ConAddressID">
          <el-select v-model="form.ConAddressID" clearable placeholder="请选择咨询地点">
            <el-option v-for="item in ConAddressitemlist" :key="item.ConAddressID" :label="item.ConAddressName"
              :value="item.ConAddressID + '|' + item.AliasName"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排班时间" prop="Consulting_time">
          <el-time-picker v-model="form.Consulting_time[0]" value-format="HH:mm" format="HH:mm" placeholder="排班开始时间">
          </el-time-picker>
          至
          <el-time-picker v-model="form.Consulting_time[1]" value-format="HH:mm" format="HH:mm" placeholder="排班结束时间">
          </el-time-picker>
        </el-form-item>

        <el-form-item label="咨询方式" prop="ConsultType">
          <el-select v-model="form.ConsultType" placeholder="请选择咨询方式">
            <el-option label="面对面咨询" value="0"></el-option>
            <el-option label="远程视频" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="save-item">
          <el-button :loading="loadisngs" type="success" @click="Submit_account('form')" >保存</el-button>
        </el-form-item>

      </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data(){
    return {
      loadisngs:false,
      FiveDifficultySplicing:'',
      form: {
        UserID:(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))?this.Global.userID:'',
        Consultant: '', //咨询师编号
        ConAddressID: '', //咨询地址ID
        ConsultType: "", //咨询方式
        SchedulDate: '', //排班日期
        Consulting_time: ['', ''],
        TimeRange: '',
      },
      pickerOptions: '',
      CounselorList:[],
      RoleID:sessionStorage.getItem('RoleID'),
      data:[],
      fxtj:[],
      wk1:[],
      wk2:[],
      wk3:[],
      wk4:[],
      wk5:[],
      dialogVisible:false,
      selectAllConsultantdata:[],
      urgentStatus:'',
      wuserID:'',
      reportStatus:'',
      VsitorNameList:[],
      ConAddressitemlist: [], //咨询地点下拉框列表
    }
  },
  methods:{
    getVsitorNameList(keyword) {
      if (keyword !== '') {
        this.$Http_Post('ConsultSubscribe/GetStudentList', {
          Keyword: keyword,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },
    Submit_account() {
      this.loadisngs = true
      if (this.form.ConsultType == "") {
        this.loadisngs = false;
        this.Global.request_failure('请选择咨询方式');
        return false;
      } else if (this.form.ConAddressID == '') {
        this.loadisngs = false;
        this.Global.request_failure('请选择咨询地点');
      }else if (this.form.SchedulDate == '') {
        this.loadisngs = false;
        this.Global.request_failure('请选择咨询日期');
      }else if (this.form.Consultant == '') {
        this.loadisngs = false;
        this.Global.request_failure('请选择咨询师');
      }else if (this.form.UserID == '') {
        this.loadisngs = false;
        this.Global.request_failure('请输入并选择学生');
      }else if (!((Number(this.form.Consulting_time[1].slice(0, 2))) - Number(this.form.Consulting_time[0].slice(0, 2)) >= 1 && (Number(this.form.Consulting_time[1].slice(3, 5))) == Number(this.form.Consulting_time[0].slice(3, 5)))) {
        this.loadisngs = false;
        this.Global.request_failure('时间间隔只能为一个小时！');
      }else {
       
        this.$Http_Post('ConsultSubscribe/AddFastSchedul', {UserID: this.form.UserID,Consultant: this.form.Consultant,//咨询师数组
          ConAddressKey: this.form.ConAddressID.split('|')[0],ConsultType: this.form.ConsultType,SchedulDate: this.form.SchedulDate,TimeRange:this.form.Consulting_time.join("-"),keyNo: this.data.KeyNo}).then((res) => {
            this.loadisngs = false
            if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.dialogVisible = false;
          } else {
            this.$message({
              type: 'warning',
              message: res.Message,
            });
          }
        });
      }
    },
    selectAllConsultantfun(){
      this.$Http_Post('/management/distressPrediction/selectAllConsultant', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.selectAllConsultantdata = res.Data;
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then((_) => {
        done();
      })
      .catch((_) => { });
    },
  },
  mounted() {
    
    this.$Http_Post('ConsultSubscribe/GetConAddress', {}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.ConAddressitemlist = res.Data;
      }
    });

    this.$Http_Post('ConsultAppoint/GetScheduleParams').then((res) => {
      if (res.Code == 0) {
        this.CounselorList = res.Data.CounselorList;
        this.Days = res.Data.Days;
      }
    });

    this.reportStatus = this.$route.query.reportStatus;
    this.selectAllConsultantfun();
    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', {keyNo: [this.$route.query.KeyNo][0]}).then((res) => {
      if (res.Code == 0) {
        this.data = res.Data;
        this.form.UserID = res.Data.userID;
        this.urgentStatus = res.Data.urgentStatus;
        this.FiveDifficultySplicing = res.Data.FiveDifficultySplicing;
      }
    });
  }
}
</script>
<style scoped>
  .Crisis_detail{width:100%;height: 100%;background-color: #fff;}
  .Crisis_detail .hoi{width: 96%;margin-left: 2%;padding-top: 20px;}
  .Crisis_detail .el-dialog__body{height: 600px !important;}
  .el-dialog__body {height: 600px !important;}
</style>